import { FC } from 'react';
import { SelectTriggerCount } from './components/MultiSelectDesktop/components/SelectTriggerCount';
import { MultiSelectTriggerProps, TriggerKind } from './types';

type TriggerComponent = FC<MultiSelectTriggerProps>;

const kindToTrigger: Partial<Record<TriggerKind, TriggerComponent>> = {
  count: SelectTriggerCount
  // chips: SelectTriggerChips
};

export const getTrigger = (kind: TriggerKind): TriggerComponent =>
  kindToTrigger[kind] ?? SelectTriggerCount;
